import { render } from "./HasMoreTile.vue?vue&type=template&id=e98f972e"
import script from "./HasMoreTile.vue?vue&type=script&lang=js"
export * from "./HasMoreTile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__